import { render, staticRenderFns } from "./InformationAdd.vue?vue&type=template&id=edd529ec&scoped=true"
import script from "./InformationAdd.vue?vue&type=script&lang=js"
export * from "./InformationAdd.vue?vue&type=script&lang=js"
import style0 from "./InformationAdd.vue?vue&type=style&index=0&id=edd529ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd529ec",
  null
  
)

export default component.exports